import { ITagQueryItem } from "src/app/api/api-bar-management.service.generated";



export class TagsConverter {
    static toTag(tag: string): ITagQueryItem | undefined {
        const kv = tag.split(':');
        if (kv.length !== 2 || !kv[0] || !kv[1]) return undefined;
        return {tag: kv[0], value: kv[1]}
    }

    static fromTag(tag: ITagQueryItem): string {
        return `${tag.tag}:${tag.value}`;
    }

    static toTags(tags: string[]): ITagQueryItem[] {
        return tags ? tags.map(t => this.toTag(t)).filter(t => t) : undefined;
    }

    static fromTags(tags: ITagQueryItem[]): string[] {
        return tags ? tags.map(t => this.fromTag(t)) : undefined;
    }

    static areTagsEqual(t1: ITagQueryItem, t2: ITagQueryItem) {
        return t1.tag === t2.tag && t1.value === t2.value;
    }
}